//@flow
import invariant from 'invariant'
export const BATCH = '@@BATCH'

export type BatchAction = {
  type: string,
  payload: any[],
  meta: ?{ [string]: boolean }
}

export function batchReducer(
  reducer: (state: any, action: BatchAction) => any
) {
  return function(state: any, action: BatchAction) {
    if (action.type === BATCH || (action.meta && !!action.meta[BATCH])) {
      return action.payload.reduce(reducer, state)
    }
    return reducer(state, action)
  }
}

// Array<Object> type is for spread operators in array actions
export function batch(...actions: Array<string | Object | Array<Object>>): any {
  let fsas = actions
  let actionType: string = BATCH
  let useCustomActionType = false
  if (typeof actions[0] === 'string') {
    actionType = actions[0]
    fsas = actions.slice(1)
    useCustomActionType = true
  }
  const flattenedActions = [].concat.apply([], fsas)
  invariant(
    Array.isArray(flattenedActions) &&
      flattenedActions.every(a => typeof a === 'object'),
    'batch() expects an array of basic Redux actions'
  )

  const action: BatchAction = {
    type: actionType,
    payload: flattenedActions,
    meta: useCustomActionType ? { [BATCH]: true } : undefined
  }
  return action
}



// WEBPACK FOOTER //
// ./src/modules/lib/batchReducer.js